import React from 'react'
import { View, StyleSheet, Image } from 'react-native'
import Colors from '../../../constants/Colors'
import Paths from '../../../constants/Paths'
import { CustomText } from '../../text/StyledText'
import { BorderStyles, ShadowStyles } from '../../../styles'
import CustomPressable from "../../pressables/CustomPressable"

export default class Story extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <View style={styles.container}>
        <CustomPressable
          activeOpacity={0.75}
          onPress={this.props.onPressAction}
        >
          <View style={styles.storyContainer}>
            <Image
              source={{
                uri: Paths.storyUrlBase + this.props.item.filename,
              }}
              resizeMode="cover"
              style={styles.storyImage}
              accessibilityIgnoresInvertColors
            />
            <CustomText font={'bold'} style={styles.titleText}>
              {this.props.item.title}
            </CustomText>
            <CustomText style={styles.introText} numberOfLines={3}>
              {this.props.item.teaser}
            </CustomText>
          </View>
        </CustomPressable>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    ...ShadowStyles.cardShadow,
    borderRadius: 10,
    flex: 1,
    margin: 10,
  },
  introText: {
    minHeight: 40,
    textAlign: 'center',
  },
  storyContainer: {
    alignItems: 'center',
    padding: 15,
  },
  storyImage: {
    borderRadius: 75,
    height: 150,
    width: 150,
    ...BorderStyles.blueBorder,
  },
  titleText: {
    marginBottom: 12,
    marginTop: 6,
    textAlign: 'center',
  },
})
